import { render } from "./myAddress.vue?vue&type=template&id=01ae8339&scoped=true"
import script from "./myAddress.vue?vue&type=script&lang=js"
export * from "./myAddress.vue?vue&type=script&lang=js"

import "./myAddress.vue?vue&type=style&index=0&id=01ae8339&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ae8339"]])

export default __exports__